import { RootState } from "store";
import { selectUserId } from "modules/auth/redux/selectors";
import { IUserRoomState } from "modules/room/redux/roomSlice";
import { createSelector } from "@reduxjs/toolkit";
import getRoomId from "../utils";
import { IUserRoomStatus } from "../userRoomStatus";

const selectUserRoomStatus = (state: RootState): IUserRoomState =>
  state.userRoomStatus;
const makeSelectUserRoomStatusByRoomId =
  (roomId?: string | null) =>
  ({ userRoomStatus }: RootState): Record<string, IUserRoomStatus> | null =>
    roomId ? userRoomStatus[roomId] : null;

// Returns room Id of current user based on UserRoomStatus
const makeSelectUserRoomStatusByUserId =
  (userId?: string) =>
  ({ userRoomStatus }: RootState): string | null => {
    if (!userId || !userRoomStatus) {
      return null;
    }

    return (
      Object.keys(userRoomStatus).find((roomId: string) =>
        Boolean(userRoomStatus[roomId][userId]),
      ) ?? null
    );
  };

const selectCurrentRoomId = createSelector(
  selectUserRoomStatus,
  selectUserId,
  (userRoomStatus, userId) => {
    if (userId) {
      return getRoomId(userId, userRoomStatus);
    }
    return null;
  },
);

const selectUsersCountInRoom =
  (roomId: string) =>
  ({ userRoomStatus }: RootState): number =>
    Object.keys(userRoomStatus?.[roomId] ?? {}).length;

export {
  selectUserRoomStatus,
  makeSelectUserRoomStatusByRoomId,
  makeSelectUserRoomStatusByUserId,
  selectCurrentRoomId,
  getRoomId,
  selectUsersCountInRoom,
};
